import React from "react";
import { useMutation } from "react-query";
import { DEFAULT_PER_PAGE } from "../../../../helpers/default";
import ContentBlock from "../../../../components/Layout/ContentBlock";
import FilterMenu from "../../../../components/Layout/FilterMenu";
import {
  ButtonSecondary,
  Pagination,
  TextInput,
} from "../../../../components/globals";
import TableFilterBox from "../../../../components/common/TableFilterBox";
import {
  ButtonDelete,
  ButtonEditRow,
} from "../../../../components/common/Buttons";
import {
  antdAsyncMessageError,
  antdAsyncMessageSuccess,
} from "../../../../helpers/AsyncMessage";
import { Modal } from "antd";
import { useModal } from "../../../../hooks";
import { InputSwitchComponent } from "../../../../components/globals";
import { IconBanners } from "../../../../components/Layout/Icons";
import { SelectForm } from "../../../../components/common/Buttons";
import { AiOutlineDesktop } from "react-icons/ai";
import {
  IconMobile,
  IconChevronUp,
  IconChevronDown,
} from "../../../../components/Layout/Icons";
import RangePickerComp from "../../../../components/common/RangePickerComp";
import { getDateFormat } from "../../../../helpers/Utils";
import ImageWithPreviewModal from "./modals/ImageWithPreviewModal";
import SwitchComp from "../../../../components/common/SwitchComp";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import ModalNewBanner from "./modals/ModalNewLandingBanner";
import { useQuery } from "react-query";
import axios from "axios";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import MarketingFeatureTabUi from "./MarketingFeatureTabUi";
import ContentValidation from "../../../../components/common/ContentValidation";

dayjs.extend(isBetween);

const { confirm } = Modal;

const Landing = ({ tabId, setTabId, onSupplierNameChange }) => {
  const [page, setPage] = React.useState(1);
  const [perPage, setPerPage] = React.useState(DEFAULT_PER_PAGE);
  const [totals, setTotals] = React.useState(0);
  const [filterSelectedShop, setFilterSelectedShop] = React.useState("");
  const [filterTitle, setFilterTitle] = React.useState("");
  const [filterDatePeriod, setFilterDatePeriod] = React.useState([]);
  const [filterCustomEvent, setFilterCustomEvent] = React.useState("");
  const [filterStatus, setFilterStatus] = React.useState("");
  const [clickCount, setClickCount] = React.useState(0);

  const { modalOpt, setModalOpt, closeModal } = useModal();

  const fetchOrderShops = async () => {
    const response = await axios.get("/api/v1/order_shops");
    return response.data;
  };

  const { data: orderShops } = useQuery("orderShops", fetchOrderShops);
  const ALLOWED_SHOPS = ["BB LT", "BB LV", "BB EE", "BB FI", "TR LT"];
  const allShops = orderShops?.shops || [];
  const shops = allShops.filter(s => ALLOWED_SHOPS.includes(s.label));

  const fetchBanners = async () => {
    let url = `/api/v1/banners?page=${page}&per_page=${perPage}&q[banner_place_eq]=landing`;
    if (filterTitle) {
      url += `&q[title_i_cont]=${filterTitle}`;
    }
    if (filterCustomEvent) {
      url += `&q[custom_event_i_cont]=${filterCustomEvent}`;
    }
    if (filterDatePeriod?.length) {
      url += `&q[valid_to_gteq]=${filterDatePeriod[0]}&q[valid_from_lteq]=${filterDatePeriod[1]}`;
    }
    if (filterSelectedShop) {
      url += `&q[banner_shops_order_shop_id_eq]=${filterSelectedShop}`;
    }
    if (filterStatus) {
      url += `&q[banner_shops_active_true]=${filterStatus}`;
    }
    if (clickCount === 1) {
      url += `&q[s]=sort_order asc`;
    } else if (clickCount === 2) {
      url += `&q[s]=sort_order desc`;
    }
    const response = await axios.get(url);
    return response.data;
  };

  const {
    data: banners,
    isLoading: bannersLoading,
    error: bannersError,
    refetch: refetchBanners,
  } = useQuery("banners", fetchBanners);

  const handleFilterChange = () => {
    refetchBanners();
  };

  const switchStatusMutation = useMutation({
    mutationFn: (value) => {
      console.log(value);
      const formData = new FormData();
      formData.append("banner[banner_shops_attributes][0][id]", value.shopId);
      formData.append(
        "banner[banner_shops_attributes][0][active]",
        value.active
      );

      return axios.put(`/api/v1/banners/${value.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: () => {
      antdAsyncMessageSuccess({
        text: "Successfully updated",
        key: "update_banner",
      });
      refetchBanners();
    },
    onError: () => {
      antdAsyncMessageError({
        text: "Error occurred",
        key: "update_banner_error",
      });
    },
  });

  const deleteBannerMutation = useMutation(
    (id) => axios.delete(`/api/v1/banners/${id}`),
    {
      onSuccess: () => {
        antdAsyncMessageSuccess({
          text: "Successfully deleted",
          key: "delete_banner",
        });
        refetchBanners();
      },
      onError: () => {
        antdAsyncMessageError({
          text: "Error occurred",
          key: "delete_banner",
        });
      },
    }
  );

  const handleClick = () => {
    setClickCount((prevCount) => (prevCount === 2 ? 0 : prevCount + 1));
  };

  const handleFilterClear = () => {
    setFilterCustomEvent("");
    setFilterTitle("");
    setFilterDatePeriod([]);
    setFilterSelectedShop("");
    setFilterStatus("");
  };

  React.useEffect(() => {
    if (banners?.totals) {
      setTotals(banners?.totals);
    }
  }, [banners]);

  React.useEffect(() => {
    refetchBanners();
  }, [page, perPage]);

  React.useEffect(() => {
    refetchBanners();
  }, [modalOpt]);

  React.useEffect(() => {
    refetchBanners();
  }, [clickCount]);
  return (
    <>
      <ContentBlock>
        <FilterMenu
          length={banners?.totals}
          text2={`Banners`}
          iconComponent={<IconBanners />}
          onChangeCountPage={setPerPage}
          countPage={perPage}
          page={page}
          totals={banners?.data?.totals}
        />
      </ContentBlock>
      <div className="col-12">
        <MarketingFeatureTabUi tabId={tabId} setTabId={setTabId} />
      </div>
      <ContentBlock containerClass="py-1">
        <TableFilterBox
          filter={true}
          onFilter={() => {
            handleFilterChange();
          }}
          add={false}
          clearFilter={() => handleFilterClear()}
          button1={
            <>
              <div className="float-left ml-2" style={{ width: 104 }}>
                <ButtonSecondary
                  onClick={() => setModalOpt("new_landing_banner", 0)}
                >
                  New banner
                </ButtonSecondary>
              </div>
            </>
          }
        >
          <div className="d-flex justify-content-between flex-1 flex-wrap">
            <div className="d-flex flex-wrap">
              <>
                <div className="px-1">
                  <TextInput
                    text="Title"
                    name="Title"
                    style={{ width: 165 }}
                    value={filterTitle}
                    onChange={(val) => {
                      setFilterTitle(val.target.value);
                    }}
                  />
                </div>
                <div className="px-1">
                  <RangePickerComp
                    style={{ width: "250px" }}
                    label="Date period"
                    showTime={{ format: "HH:mm" }}
                    placeholder={["Start time", "End time"]}
                    value={
                      filterDatePeriod
                        ? [
                          getDateFormat(filterDatePeriod[0]),
                          getDateFormat(filterDatePeriod[1]),
                        ]
                        : ["", ""]
                    }
                    onChange={(_, value) => {
                      setFilterDatePeriod(value);
                    }}
                    disabledDate={() => false}
                  />
                </div>
                <div className="px-1">
                  <TextInput
                    text="Custom event"
                    name="Custom event"
                    style={{ width: 165 }}
                    value={filterCustomEvent}
                    onChange={(val) => {
                      setFilterCustomEvent(val.target.value);
                    }}
                  />
                </div>
                <div className="px-1">
                  <SelectForm
                    placeholder="Shop"
                    options={[{ value: null, label: " " }, ...shops]}
                    selector="shop"
                    style={{ width: 165 }}
                    value={filterSelectedShop}
                    onChange={(shop) => setFilterSelectedShop(shop)}
                  />
                </div>
                <div className="px-1">
                  <InputSwitchComponent
                    label="Status"
                    name="auto_type"
                    options={[
                      {
                        label: "All",
                        value: "",
                      },
                      {
                        label: "Enabled",
                        value: "true",
                      },
                      {
                        label: "Disabled",
                        value: "false",
                      },
                    ]}
                    value={filterStatus}
                    onChange={(val) => {
                      setFilterStatus(val.target.value);
                    }}
                  />
                </div>
              </>
            </div>
          </div>
        </TableFilterBox>
        <div>
          <div className="table-responsive" style={{ overflow: "hidden" }}>
            <ContentValidation
              loader={bannersLoading}
              array={banners?.data}
              error={bannersError}
            >
              <table className="table mt-3">
                <thead>
                  <tr className="text-muted">
                    <th className="text-black">Title</th>
                    <th className="text-black">Valide period</th>
                    <th className="text-black">Custom event</th>
                    <th className="text-black d-flex align-items-center">
                      Order in carousel
                      <div
                        className="d-flex flex-column ml-1 cursor-pointer"
                        onClick={handleClick}
                      >
                        <IconChevronUp
                          fill={clickCount === 1 ? "#5F5F5F" : "#BFBFBF"}
                        />
                        <IconChevronDown
                          fill={clickCount === 2 ? "#5F5F5F" : "#BFBFBF"}
                        />
                      </div>
                    </th>
                    <th className="text-black">Shop</th>
                    <th className="text-black">Status</th>
                    <th className="text-black">
                      <div
                        className="d-flex justify-content-center"
                        style={{ width: "100%" }}
                      >
                        <AiOutlineDesktop />
                      </div>
                    </th>
                    <th className="text-black">
                      <div
                        className="d-flex justify-content-center"
                        style={{ width: "100%" }}
                      >
                        <IconMobile />
                      </div>
                    </th>
                    <th className="text-black"></th>
                  </tr>
                </thead>
                <tbody>
                  {banners?.data?.map?.((item) => (
                    <tr className="align-middle tableColumn" key={item.id}>
                      <td className="align-middle">{item?.title}</td>
                      <td className="align-middle">
                        <div className="d-flex flex-row align-items-center">
                          <div
                            className="dot"
                            style={{
                              backgroundColor: dayjs().isBetween(
                                dayjs(item?.valid_from),
                                dayjs(item?.valid_to)
                              )
                                ? "#28A745"
                                : "#C94747",
                            }}
                          />
                          {`${dayjs(item?.valid_from).format(
                            "YYYY-MM-DD HH:mm"
                          )} - ${dayjs(item?.valid_to).format(
                            "YYYY-MM-DD HH:mm"
                          )}`}
                        </div>
                      </td>
                      <td className="align-middle">{item?.custom_event}</td>
                      <td className="align-middle">{item?.sort_order}</td>
                      <td className="align-middle">
                        {item?.banner_shops?.map?.((shop, index) => (
                          <div
                            key={"shop.order_shop.title" + index}
                            className="d-flex justify-content-center align-items-center grey-tabblet"
                          >
                            <p className="mb-0 mt-0">{shop.order_shop.title}</p>
                          </div>
                        ))}
                      </td>
                      <td className="align-middle">
                        {item?.banner_shops?.map?.((shop, index) => (
                          <div
                            key={"shop.active" + index}
                            className="d-flex align-items-center switch-container"
                          >
                            <SwitchComp
                              className=""
                              checked={shop.active}
                              onChange={() =>
                                switchStatusMutation.mutate({
                                  id: item?.id,
                                  shopId: shop?.id,
                                  active: !shop.active,
                                })
                              }
                            />
                          </div>
                        ))}
                      </td>
                      <td className="align-middle">
                        <div
                          className="d-flex justify-content-center flex-column align-items-center"
                          style={{ width: "100%" }}
                        >
                          {item?.banner_shops?.map?.((shop, index) => (
                            <ImageWithPreviewModal
                              key={"shop?.desktop_image" + index}
                              asset={{
                                url:
                                  shop?.desktop_image ||
                                  "https://via.placeholder.com/150",
                              }}
                              created_at={item?.created_at}
                              id={item?.id}
                              height={30}
                            />
                          ))}
                        </div>
                      </td>
                      <td className="align-middle">
                        <div
                          className="d-flex justify-content-center flex-column align-items-center"
                          style={{ width: "100%" }}
                        >
                          {item?.banner_shops?.map?.((shop, index) => (
                            <ImageWithPreviewModal
                              key={"shop?.mobile_image" + index}
                              asset={{
                                url:
                                  shop?.mobile_image ||
                                  "https://via.placeholder.com/150",
                              }}
                              created_at={item?.created_at}
                              id={item?.id}
                              height={30}
                            />
                          ))}
                        </div>
                      </td>
                      <td className="align-middle">
                        <div className="d-flex justify-content-end gap-5">
                          <ButtonEditRow
                            className="d-flex justify-content-center align-items-center"
                            onClick={() =>
                              setModalOpt("edit_landing_banner", item.id)
                            }
                          />
                          <ButtonDelete
                            className="d-flex justify-content-center align-items-center"
                            onDelete={() =>
                              confirm({
                                title: "Are you sure?",
                                icon: (
                                  <ExclamationCircleOutlined className="text-primary" />
                                ),
                                content:
                                  "You will not be able to undo this action",
                                onOk() {
                                  deleteBannerMutation.mutate(item.id);
                                },
                                onCancel() {
                                  console.log("Cancel");
                                },
                              })
                            }
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </ContentValidation>
            <Pagination
              setPagination={setPage}
              page={page}
              totals={totals}
              pageCount={perPage}
            />
          </div>
        </div>
        {modalOpt.type === "new_landing_banner" && (
          <ModalNewBanner
            onClose={closeModal}
            modalOpt={modalOpt}
            orderShops={shops}
          />
        )}
        {modalOpt.type === "edit_landing_banner" && (
          <ModalNewBanner
            onClose={closeModal}
            modalOpt={modalOpt}
            orderShops={shops}
            bannerData={banners?.data}
          />
        )}
      </ContentBlock>
    </>
  );
};

export default Landing;
